import { Button } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { useGlobalSearchContext } from "../context";
import { isSearchCompany } from "../types";
import { CompanySearchItem } from "./CompanySearchItem";
import { EmployeeSearchItem } from "./EmployeeSearchItem";
import { EmptyState } from "./EmptyState";
import { SectionHeader } from "./SectionHeader";

export const RecentSearch = () => {
  const { t } = useI18n();
  const { recentSearches, clearRecentSearches } = useGlobalSearchContext();

  if (recentSearches.length === 0) {
    return <EmptyState variant="idle" />;
  }

  return (
    <div className="flex flex-col">
      <SectionHeader
        title={t("apps.admin.common.recentSearch")}
        accessory={
          <Button
            variant="ghost"
            color="neutral"
            size="xs"
            className="text-neutral-500/50"
            onClick={clearRecentSearches}
          >
            {t("apps.admin.common.clear")}
          </Button>
        }
      />

      {recentSearches.map((recent) => {
        if (isSearchCompany(recent)) {
          return <CompanySearchItem key={recent.id} company={recent} />;
        }
        return <EmployeeSearchItem key={recent.id} employee={recent} />;
      })}
    </div>
  );
};
